export type Sponsor = {
  name: string
  sponsorType: 'official' | 'proud'
  image: string
  link: string
}

export const sponsorList: Sponsor[] = [
  {
    name: 'Ticketmaster',
    sponsorType: 'official',
    image: `https://premierlacrosseleague.com/wp-content/uploads/2021/04/PLL_OfficialPartners_Logos_Ticketmaster.jpg`,
    link: `https://www.ticketmaster.com/`,
  },
  {
    name: 'Whirlpool',
    sponsorType: 'official',
    image: `https://premierlacrosseleague.com/wp-content/uploads/2023/11/WhirlpoolBRAND-R-2017Logo-B.webp`,
    link: `https://www.whirlpool.com/`,
  },
  {
    name: 'Cash App',
    sponsorType: 'official',
    image: `https://premierlacrosseleague.com/wp-content/uploads/2022/07/cash_app-e1659123916627.png`,
    link: `https://cash.app/`,
  },
  {
    name: 'Champion',
    sponsorType: 'official',
    image: `https://premierlacrosseleague.com/wp-content/uploads/2021/04/PLL_OfficialPartners_Logos_Champion.jpg`,
    link: `https://www.champion.com/`,
  },
  {
    name: 'Lexus',
    sponsorType: 'official',
    image: `https://premierlacrosseleague.com/wp-content/uploads/2025/01/Lexus_Logo_Horizontal_Black_on_White.webp`,
    link: `https://www.lexus.com/`,
  },
  {
    name: 'Progressive',
    sponsorType: 'official',
    image: `https://premierlacrosseleague.com/wp-content/uploads/2021/04/PLL_OfficialPartners_Logos_Progressive.jpg`,
    link: `https://www.progressive.com/`,
  },
  {
    name: 'Metabilia',
    sponsorType: 'official',
    image: `https://premierlacrosseleague.com/wp-content/uploads/2024/01/Web-Sponsor-Request-Logo.png`,
    link: `https://metabilia.io/`,
  },
  {
    name: 'STX',
    sponsorType: 'official',
    image: `https://premierlacrosseleague.com/wp-content/uploads/2020/02/Sponsors_web_STX.jpg`,
    link: `https://www.stx.com/`,
  },
  {
    name: 'Rebel Bourbon',
    sponsorType: 'official',
    image: `https://premierlacrosseleague.com/wp-content/uploads/2023/08/rebel_bourbon.webp`,
    link: `https://rebelbourbon.com/`,
  },
  {
    name: 'DUDE Wipes',
    sponsorType: 'official',
    image: `https://premierlacrosseleague.com/wp-content/uploads/2023/08/f97d2da02dc6-DudeWipes_Logo_2_Black_01__1_.png`,
    link: `https://dudeproducts.com/`,
  },
  {
    name: 'Gatorade',
    sponsorType: 'official',
    image: `https://premierlacrosseleague.com/wp-content/uploads/2024/01/gatorade-partner.webp`,
    link: `https://www.gatorade.com/`,
  },
  {
    name: 'Cascade',
    sponsorType: 'official',
    image: `https://premierlacrosseleague.com/wp-content/uploads/2021/04/PLL_OfficialPartners_Logos_Cascade.jpg`,
    link: `https://cascadelacrosse.com/`,
  },
  {
    name: 'Warrior',
    sponsorType: 'official',
    image: `https://premierlacrosseleague.com/wp-content/uploads/2022/04/793611af50f0-Warrior_Stack_Logo.png`,
    link: `https://www.warrior.com/`,
  },
  {
    name: 'Q-Collar',
    sponsorType: 'official',
    image: `https://premierlacrosseleague.com/wp-content/uploads/2022/04/9dc380f1a1d4-Logo_200x200.png`,
    link: `https://qcollar.com/`,
  },
  {
    name: `Duke Cannon`,
    sponsorType: 'official',
    image: `https://premierlacrosseleague.com/wp-content/uploads/2024/05/DukeCannon-Logo-Primary.webp`,
    link: `https://dukecannon.com/`,
  },
  {
    name: 'Athletic Brewing',
    sponsorType: 'official',
    image: `https://img.premierlacrosseleague.com/Sponsors/2023/Athletic_Lockup_Navy_010123-2000x2263-932f579.png`,
    link: `https://athleticbrewing.com/`,
  },
  {
    name: 'Utah Sports Commission',
    sponsorType: 'official',
    image: `https://premierlacrosseleague.com/wp-content/uploads/2024/01/USC-Horizontal.png`,
    link: `https://utahsportscommission.com/`,
  },
  {
    name: 'ECD',
    sponsorType: 'official',
    image: `https://premierlacrosseleague.com/wp-content/uploads/2020/02/Sponsors_web_ecdlacrosse.jpg`,
    link: `https://www.ecdlax.com/`,
  },
  {
    name: 'VensureHR',
    sponsorType: 'official',
    image: `https://premierlacrosseleague.com/wp-content/uploads/2024/04/VensureHR-CMYK-Vertical.webp`,
    link: `https://www.vensure.com/`,
  },
  {
    name: 'VukGripz',
    sponsorType: 'official',
    image: `https://premierlacrosseleague.com/wp-content/uploads/2022/07/Vukgripz_Vukgripz_Black_Green_RG.png`,
    link: `https://vukgripz.com/collections/lacrosse-tape`,
  },
  {
    name: 'New Balance',
    sponsorType: 'official',
    image: `https://premierlacrosseleague.com/wp-content/uploads/2024/01/New-Balance-logo.png`,
    link: `https://www.newbalance.com/`,
  },
  {
    name: 'Onrise Care',
    sponsorType: 'official',
    image: `https://premierlacrosseleague.com/wp-content/uploads/2024/04/Onrise-Logo-from-Sponsor-Request.webp`,
    link: `https://onrise.care/`,
  },
  {
    name: 'Cenegenics',
    sponsorType: 'official',
    image: `https://premierlacrosseleague.com/wp-content/uploads/2024/09/CENEGENICS-LOGO-Deep-Turquoise.webp`,
    link: `https://cenegenics.com/`,
  },
  {
    name: 'Fourg Athletics',
    sponsorType: 'official',
    image: `https://premierlacrosseleague.com/wp-content/uploads/2024/01/708639ac7802-Fourg_Athletics_Logo.webp`,
    link: `https://www.fourgathletics.com/`,
  },
  {
    name: 'ONS',
    sponsorType: 'official',
    image: `https://premierlacrosseleague.com/wp-content/uploads/2025/01/ONS_Logo.webp`,
    link: `https://www.onsmd.com/`,
  },
  {
    name: 'TruFIT Customs',
    sponsorType: 'official',
    image: `https://premierlacrosseleague.com/wp-content/uploads/2025/01/TruFIT_Logo.webp`,
    link: `https://trufitcustoms.com/`,
  },
]
